import React from 'react';

function IadePage() {
  return (
    <div className="bg-white p-6 sm:p-8 rounded-lg shadow-md max-w-4xl mx-auto prose">
      <h1 className="text-3xl font-bold text-brand-green mb-4">İptal ve İade Koşulları</h1>
      
      <h2>İade Şartları</h2>
      <p>Satın aldığınız ürünleri, teslimat tarihinden itibaren 14 gün içinde, kullanılmamış, etiketleri sökülmemiş ve orijinal ambalajında olacak şekilde iade edebilirsiniz.</p>
      
      <h2>Değişim Şartları</h2>
      <p>Ürün değişimi yapmak isterseniz, iade prosedürünü takip ederek ürünü tarafımıza göndermeniz ve yeni bir sipariş oluşturmanız gerekmektedir.</p>
      
      <h2>Geri Ödeme Süreci</h2>
      <p>İade ettiğiniz ürünler tarafımıza ulaştıktan sonra kalite kontrol sürecinden geçer. İade şartlarına uygun olduğu onaylanan ürünlerin ücret iadesi, ödeme yaptığınız yönteme göre 3-7 iş günü içinde gerçekleştirilir.</p>
    </div>
  );
}

export default IadePage;